import { Injectable, } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthorRoleService {

  private roles = [
    {
      rolecode: 56,
      authorrole: "Director",
      priority: 1
    },
    {
      rolecode: 64,
      authorrole: "Subdirector",
      priority: 5
    },
    {
      rolecode: 66,
      authorrole: "Presidente",
      priority: 10
    },
    {
      rolecode: 63,
      authorrole: "Vicepresidente",
      priority: 15
    },
    {
      rolecode: 71,
      authorrole: "Vicedirector",
      priority: 20
    },
    {
      rolecode: 72,
      authorrole: "Editor",
      priority: 25
    },
    {
      rolecode: 54,
      authorrole: "Autor",
      priority: 30
    },
    {
      rolecode: 68,
      authorrole: "Codirector",
      priority: 35
    },
    {
      rolecode: 62,
      authorrole: "Organizador",
      priority: 40
    },
    {
      rolecode: 59,
      authorrole: "Compilador",
      priority: 45
    },
    {
      rolecode: 61,
      authorrole: "Supervisor académico",
      priority: 50
    },
    {
      rolecode: 60,
      authorrole: "Supervisor",
      priority: 55
    },
    {
      rolecode: 58,
      authorrole: "Coordinador",
      priority: 60
    },
    {
      rolecode: 65,
      authorrole: "Recopilador",
      priority: 65
    },
    {
      rolecode: 55,
      authorrole: "Traductor",
      priority: 70
    },
    {
      rolecode: 70,
      authorrole: "Actualizador",
      priority: 72
    },
    {
      rolecode: 53,
      authorrole: "Colaborador",
      priority: 75
    },
    {
      rolecode: 67,
      authorrole: "En homenaje a",
      priority: 80
    },
    {
      rolecode: 69,
      authorrole: "Editor in chief",
      priority: 85
    },
    {
      rolecode: 57,
      authorrole: "Miembro",
      priority: 90
    }
  ];

  constructor() {}

  buildAuthorsAndRoles(authorsData: any, authorsDetails: any): any[] {

    const autoresArr: any = [];

    if (typeof authorsData === 'undefined' || typeof authorsDetails === 'undefined')
      return autoresArr;

    authorsData.forEach((e: any) => {

      const autor = {
        authorcode: '',
        firstname: '',
        lastname: '',
        role: '',
        priority: 0
      };

      // Info del rol
      if (this.roles) {
        this.roles.some((r: any) => {
          if (e.role == r.rolecode) {
            autor.role =  r.authorrole;
            autor.priority = r.priority
            return true;
          }
          return false;
        });
      } else {
        // Si por algún motivo el dataprovider de Roles no existe, completamos con un rol por default
        autor.role = 'Autor';
        autor.priority = 30;
      }

      // Info del autor
      authorsDetails.some((d: any) => {
        if (e.author == d.authorcode) {
          autor.authorcode = d.authorcode;
          autor.firstname = d.firstname;
          autor.lastname = d.lastname;
          return true;
        }
        return false;
      });

      if (autor.authorcode)
        autoresArr.push(autor);
    });

    return this.sortAuthors(autoresArr);
  }

  getAuthorRole(rolecode: number): string {
    let roleName = '';
    if (this.roles && this.roles.length > 0) {
      this.roles.forEach((r: any) => {
        if (rolecode == r.rolecode)
          roleName = r.authorrole;
      });
    }
    return roleName;
  }

  // Menor es la prioridad del rol del autor, más importante es el mismo
  sortAuthors(authors: any) {
    if (authors && authors.length > 0) {
      authors.sort((a: any, b: any) => {
        if (a.priority < b.priority) {
          return -1;
        } if (a.priority > b.priority) {
          return 1;
        }
        return 0;
      });
    }
    return authors;
  }

}
